import React from "react";
import { Grid, Button } from "@material-ui/core";
import * as Styles from "../styles/BidIncrementStyles";
import { currencyFormat } from "../../../helpers/text-format/TextFormat";
import { Auction } from "../../../services/AuctionService";

interface BidIncrementProps {
  pendingBid: number | null;
  isDisabled: boolean;
  currentBidValue: number | null;
  auction: Auction;
  onBidValueSelected(amount: number): void;
}

const getIncrements = (currentBid: number | null, bidIncrement: number): (number | null)[] => {
  if (!currentBid) return [null, null, null, null];

  currentBid = Math.ceil(currentBid / 10) * 10;
  const sequence: number[] = [1, 2, 5, 10];

  if (!bidIncrement || bidIncrement === 0) {
    bidIncrement = 10;
  }

  return sequence.map(f => currentBid! + bidIncrement * f);
};

const BidIncrements: React.FC<BidIncrementProps> = ({ pendingBid, isDisabled, currentBidValue, auction, onBidValueSelected }) => {
  const classes = Styles.BidIncrementStyles();

  const increments = getIncrements(currentBidValue, auction.bidIncrement);

  return (
    <div className={classes.padding}>
      <Grid container spacing={1}>
        {increments.map((increment: number | null, index: number) => {
          const disabled = isDisabled || !increment || (pendingBid !== null && increment <= pendingBid)
          return (
            <Grid item xs={6} key={index}>
              <Button
                className={disabled ? classes.disabledButton : classes.button}
                onClick={() => increment && onBidValueSelected(increment)}
                fullWidth
                disabled={disabled}
              >
                {!increment && "Loading..."}
                {increment && currencyFormat(increment)}
              </Button>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};
export default BidIncrements;
